export const hireFlutterPageContentArabic = {
  // محتوى Helmet
  helmet: {
    title: "وظّف مطوري Flutter الخبراء",
    description: "هل تبحث عن توظيف مطوري Flutter ذوي الخبرة؟ تقدم Bitsclan محترفين ذوي خبرة ومفحوصين مسبقًا لبناء تطبيقات عالية الجودة وغنية بالميزات. حدد موعدًا لمكالمة اليوم لتبدأ!",
  },

  // محتوى HirePageBanner
  mainBanner: {
    backgroundImage: `url(/images/hire-page-images/hire-flutter.avif)`,
    mainHeading: "وظّف مطوري تطبيقات Flutter",
    content: "هل تبحث عن توظيف مطوري Flutter خبراء؟ نحن نقدم محترفين تم فحصهم مسبقًا لبناء تطبيقات محمولة عالية الأداء ومتعددة المنصات مصممة خصيصًا للشركات الناشئة والمؤسسات الكبرى.",
    btnText: "استشر مطوري Flutter لدينا",
    bannerList: [
      { list: "متعاقدون مستقلون" },
      { list: "وظائف بدوام كامل" },
      { list: "فرق عالمية" },
    ],
  },

  // محتوى HirePageExperties
  flutterExpertise: {
    btnText: "حدد موعدًا لإجراء مكالمة اليوم",
    heading: "خبرتنا في تطوير Flutter",
    description: "يتخصص مطورونا في Flutter في بناء تطبيقات متعددة المنصات سريعة وسهلة الاستخدام وغنية بالميزات. سواء كان تطبيقًا محمولًا بسيطًا أو حلاً معقدًا للمؤسسات، فإننا نضمن أداءً سلسًا عبر نظامي iOS و android.",
    servicesData: [
      {
        title: "استشارات تطبيقات Flutter",
        description: "من خلال خدماتنا الاستشارية، ستحصل على مشورة وتوجيه الخبراء لزيادة تطوير تطبيقك باستخدام Flutter إلى أقصى حد. سواء كنت تبدأ للتو أو تقوم بتحسين تطبيق موجود، سيساعدك مطورونا على تحقيق أقصى استفادة من ميزات وقدرات Flutter.",
        icon: "/images/hire-page-icons/flutter-icon-1.svg",
      },
      {
        title: "تطوير تطبيقات Flutter",
        description: "يستخدم مطورونا إطار عمل Flutter لبناء تطبيقات محمولة قابلة للتطوير وغنية بالميزات. باستخدام Flutter، يمكننا إنشاء تطبيقات توفر مظهرًا وإحساسًا متسقين عبر نظامي iOS و android، مما يقلل من وقت التطوير والتكاليف.",
        icon: "/images/hire-page-icons/flutter-icon-2.svg",
      },
      {
        title: "تطوير واجهات برمجة التطبيقات (API) باستخدام Flutter",
        description: "لدينا خبرة في بناء واجهات برمجة تطبيقات موثوقة وفعالة باستخدام Flutter. تساعد هذه الواجهات في ضمان اتصال سلس بين تطبيقك المحمول والخدمات الأخرى، مما يجعل النظام البيئي للتطبيق بأكمله يعمل بسلاسة.",
        icon: "/images/hire-page-icons/flutter-icon-3.svg",
      },
      {
        title: "تطوير أنظمة إدارة المحتوى (CMS) والبوابات باستخدام Flutter",
        description: "مطورونا ماهرون في إنشاء أنظمة إدارة محتوى (CMS) معقدة وبوابات ويب باستخدام Flutter. تم تصميم هذه الأنظمة لتكون سهلة الاستخدام وفعالة وقابلة للتطوير، مما يتيح لك إدارة المحتوى بسهولة.",
        icon: "/images/hire-page-icons/flutter-icon-4.svg",
      },
      {
        title: "الترحيل إلى Flutter",
        description: "إذا كان لديك تطبيق محمول حالي، فيمكننا مساعدتك في ترحيله إلى Flutter. سيضمن خبراء Flutter لدينا انتقالًا سلسًا، مما يساعدك على الاستفادة من مزايا Flutter، مثل التطوير الأسرع والدعم متعدد المنصات.",
        icon: "/images/hire-page-icons/flutter-icon-5.svg",
      },
      {
        title: "التكامل مع الحلول الموجودة",
        description: "يتمتع فريقنا بخبرة واسعة في دمج تطبيقات Flutter مع أنظمتك وخدماتك الحالية. سواء كان ذلك للاتصال بواجهات برمجة تطبيقات الجهات الخارجية أو المزامنة مع قواعد البيانات، فإننا نضمن أن كل شيء يعمل معًا بسلاسة.",
        icon: "/images/hire-page-icons/flutter-icon-6.svg",
      },
      {
        title: "حلول التجارة الإلكترونية باستخدام Flutter",
        description: "بالنسبة لشركات التجارة الإلكترونية، نقدم حلول Flutter قوية تعزز تجربة التسوق. من تحسين واجهات المستخدم إلى تحسين الأداء، يساعد مطورونا في Flutter في إنشاء تطبيق سريع الاستجابة وتفاعلي يعزز تفاعل العملاء.",
        icon: "/images/hire-page-icons/flutter-icon-7.svg",
      },
      {
        title: "دعم وصيانة Flutter",
        description: "نقدم دعمًا وصيانة مستمرين لتطبيقات Flutter الخاصة بك، مما يضمن بقائها فعالة ومحدثة. يساعد فريقنا في إصلاح المشكلات، وإضافة ميزات جديدة، والتأكد من أن تطبيقك يستمر في الأداء الجيد بمرور الوقت.",
        icon: "/images/hire-page-icons/flutter-icon-8.svg",
      },
    ],
  },

  // محتوى DevelopmentPerformance (لماذا تختارنا)
  whyChooseUs: {
    btnText: "توظيف مطور اليوم",
    heading: "لماذا توظف مطوري Flutter ",
    greenHeading: "من Bitsclan؟",
    subHeading: "في Bitsclan، نستفيد من قدرات Flutter مع أحدث تقنيات الهاتف المحمول والويب لتقديم تطبيقات قوية وقابلة للتطوير وعالية الأداء ومخصصة لاحتياجات عملك.",
    solutionsData: [
      {
        icon: "/images/hire-page-icons/chose-ror-section1.svg",
        title: "الوصول إلى المواهب المفحوصة",
        description: "قابل مطوري Flutter ذوي الخبرة والذين يتقنون إطار عمل Flutter ومستعدون للمساهمة في مشروعك.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section2.svg",
        title: "شاهد المطابقات في ثوانٍ",
        description: "انسَ عناء فرز مئات السير الذاتية. باستخدام HireAI، يمكنك عرض ملفات تعريف أفضل مطوري Flutter على الفور.",
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section3.svg",
        title: "وفّر مع التوظيف العالمي",
        description: "وظّف خبراء Flutter الموهوبين من أي مكان في العالم. ستصل إلى مجموعة واسعة من المطورين وستوفر ما يصل إلى 58% مقارنة بطرق التوظيف التقليدية.",
        noBorder: true,
      },
      {
        icon: "/images/hire-page-icons/chose-ror-section4.svg",
        title: "احصل على دعم بشري حقيقي",
        description: "مع فريقنا من خبراء التوظيف، تحصل على مساعدة شخصية لتوظيف أفضل مطوري Flutter لمشروعك.",
      },
    ],
  },

  // محتوى HireCombinationSection
  techCombinations: {
    heading: "أفضل تركيبات تقنية Flutter لتطوير متطور",
    description: "أطلق العنان للإمكانات الكاملة لـ Flutter مع أفضل التركيبات التقنية لبناء تطبيقات عالية الأداء ومتعددة المنصات. وظّف مطوري Flutter خبراء لضمان حلول سلسة وقابلة للتطوير ومذهلة بصريًا.",
    combinations: [
      {
        title: "Flutter + Firebase",
        description: "Flutter لتطوير متعدد المنصات و Firebase كحل للواجهة الخلفية يتيح مزامنة البيانات في الوقت الفعلي والمصادقة والتخزين السحابي لتطبيقات الهاتف المحمول والويب.",
        icons: ["Flutter.svg", "firebase.png"],
      },
      {
        title: "Flutter + Node.js + MongoDB",
        description: "Flutter للواجهة الأمامية، Node.js لمنطق الواجهة الخلفية، و MongoDB لتخزين NoSQL المرن تساعد في إنشاء تطبيقات قابلة للتطوير وديناميكية.",
        icons: ["Flutter.svg", "nodejs.svg", "mongodb.svg"],
      },
      {
        title: "Flutter + Django + PostgreSQL",
        description: "Flutter لواجهة المستخدم، Django كإطار عمل للواجهة الخلفية، و PostgreSQL لإدارة قواعد البيانات المنظمة تضمن تطوير تطبيقات آمنة وعالية الأداء.",
        icons: ["Flutter.svg", "django.svg", "postgres.svg"],
      },
      {
        title: "Flutter + GraphQL + Supabase",
        description: "GraphQL لجلب البيانات بكفاءة، Flutter لواجهة المستخدم، و Supabase كحل للواجهة الخلفية مفتوح المصدر يوفر حزمة تقنية حديثة لتطبيقات الهاتف المحمول والويب.",
        icons: ["Flutter.svg", "graphql.svg", "supabase.svg"],
      },
    ],
  },

  // محتوى HirePageSteps
  hireSteps: {
    btnText: "دعنا نجد المطور المثالي لك",
    heading: "وظّف مطوري Flutter في 4 خطوات سهلة",
    subHeading: "توظيف مطوري Flutter الخبراء أمر بسيط من خلال عمليتنا المكونة من 4 خطوات. نركز على التأكد من حصولك على المطور المناسب لمشروعك - سريعًا وموثوقًا وفعالًا من حيث التكلفة.",
    steps: [
      {
        title: "اختر نموذج التعاقد الخاص بك",
        description: "اختر نموذج التعاقد الذي يناسب احتياجاتك - دوام كامل، أو دوام جزئي، أو بالساعة.",
        icon: "/images/hire-page-setps-icons/icon-1.svg",
      },
      {
        title: "فحص واختيار مطوري Flutter",
        description: "تصفح ملفات تعريف أفضل مطوري Flutter واختر الأفضل لمشروعك.",
        icon: "/images/hire-page-setps-icons/icon-2.svg",
      },
      {
        title: "إجراء مقابلة فردية",
        description: "اجتمع مع المطورين الذين اخترتهم وقم بتقييم مهاراتهم من خلال أسئلة عملية ونظرية.",
        icon: "/images/hire-page-setps-icons/icon-3.svg",
      },
      {
        title: "إعداد مطور Flutter الخاص بك",
        description: "بمجرد اتخاذ قرارك، سينضم مطور Flutter الذي اخترته إلى فريقك في غضون 24-48 ساعة، مما يضمن عملية إعداد سريعة وسلسة.",
        icon: "/images/hire-page-setps-icons/icon-4.svg",
      },
    ],
  },

  // محتوى CoverTheStack
  coverTheStack: {
    whereStart: "الواجهة الخلفية",
    mainHeading: "أنشئ تطبيقات عالية الأداء متعددة المنصات باستخدام Flutter",
    subHeading:
      "في Bitsclan، ندعم رحلة تطوير تطبيقك من خلال حزمة تقنيات Flutter قوية تضمن أداءً سلسًا عبر منصات متعددة. يستفيد مطورونا الخبراء في Flutter من أحدث التقنيات لبناء تطبيقات محمولة وويب عالية الجودة وقابلة للتطوير ومصممة خصيصًا لاحتياجات عملك.",
    tabs: [
      "الواجهة الخلفية",
      "قاعدة البيانات",
      "الخدمات السحابية",
    ],
    tabItems: [
      { tab: "الواجهة الخلفية", icon: "/images/tech-stack-icons/dart.svg", name: "Dart" },
      { tab: "الواجهة الخلفية", name: "Firebase", icon: "/images/tech-stack-icons/firebase.png" },
      { tab: "الواجهة الخلفية", name: "Node.js", icon: "/images/database9.png" },

      { tab: "قاعدة البيانات", icon: "/images/db1.png", name: "Firebase" },
      { tab: "قاعدة البيانات", icon: "/images/db7.png", name: "SQLite" },

      { tab: "الخدمات السحابية", icon: "/images/cloud3.png", name: "AWS" },
      { tab: "الخدمات السحابية", name: "Google Cloud", icon: "/images/cloud1.png" },
    ],
  },


  // محتوى HireExpertFacts
  expertFacts: {
    btnText: "حجز موعد",
    heading: "حقائق سريعة عن ",
    greenHeading: "فريق Flutter لدينا",
    facts: [
      { text: "<strong>مطورون ذوو خبرة في Flutter:</strong> يضم فريقنا مطورين ذوي مهارات عالية ولديهم خبرة في تطوير تطبيقات Flutter." },
      { text: "<strong>خبرة متنوعة في المشاريع:</strong> لقد عملنا بنجاح على مجموعة واسعة من مشاريع تطوير تطبيقات الهاتف المحمول، وبناء حلول متعددة المنصات باستخدام Flutter." },
      { text: "<strong>تطوير سريع وفعال:</strong> يستخدم مطورونا إطار عمل Flutter لإنشاء تطبيقات بسرعة مع ضمان جودتها العالية وقابليتها للتطوير." },
      { text: "<strong>سجل حافل في تطوير تطبيقات الهاتف المحمول:</strong> يتمتع فريقنا بفهم عميق لبرمجة Dart وإطار عمل Flutter لتقديم تطبيقات محمولة من الدرجة الأولى." },
      { text: "<strong>خبرة متعددة المنصات:</strong> سواء كان ذلك لنظامي iOS أو android، نحن متخصصون في إنشاء تطبيقات تعمل بشكل جيد على كلا المنصتين." },
      { text: "<strong>دعم مستمر:</strong> يقدم مطورونا في Flutter دعمًا كاملاً طوال عملية التطوير وما بعدها، مما يساعد في الصيانة والتحديثات." },
    ],
    backgroundImage: `url(/images/hire-page-images/hire-flutter-arabic.aivf)`,
  },

  // محتوى HirePageAppIdea
  appIdeaSection: {
    heading: "لست متأكدًا من فكرة تطبيقك؟ احصل على النموذج الأولي خلال 6 إلى 8 أسابيع!",
    content: "هل لديك فكرة ولكنك غير متأكد من كيفية المتابعة؟ يمكن لخبراء Flutter لدينا مساعدتك في بناء نموذج أولي وظيفي في غضون 6-8 أسابيع فقط! تحقق من رؤيتك، واختبر تفاعل المستخدم، وأنشئ أساسًا قويًا للنجاح من خلال خدمات تطوير تطبيقات الهاتف المحمول المتخصصة لدينا.",
  },

  // خصائص مكون HirePageEngagementModels
  hirePageEngagementModels: {
    btnText: "ابدأ الآن",
    headingContent: [
      { text: "نماذج التعاقد" },
      { text: "المرنة لدينا" },
    ],
    discription: "اختر نموذج التعاقد الذي يناسب احتياجات مشروعك! سواء كنت بحاجة إلى مطورين بدوام كامل أو جزئي أو بالساعة، فإننا نقدم خيارات مرنة لضمان التعاون السلس والحد الأقصى من الكفاءة طوال مشروعك.",
    hiringDetails: [
      {
        text: "التعاقد بالساعة",
        hours: "48",
        timeUnit: "ساعة",
        icon: "time.svg",
        bgColor: "#FDFDFF",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ العمل في غضون "
      },
      {
        text: "التعاقد بدوام كامل",
        hours: "72",
        timeUnit: "ساعة",
        icon: "full-time.svg",
        bgColor: "#FFFEFA",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "ابدأ في غضون "
      },
      {
        text: "التعاقد بدوام جزئي",
        hours: "48",
        timeUnit: "ساعة",
        icon: "part-time.svg",
        bgColor: "#FDFFFA",
        durationLabel: "المدة",
        duration: "8 ساعات/يوم",
        minimumDaysLabel: "الحد الأدنى للأيام",
        minimumDays: "30 يومًا",
        billingLabel: "الفوترة",
        billing: "شهريًا",
        startWorkPhrase: "انطلق في غضون "
      },
    ],
  },

  // محتوى SecondFaq
  faqSection: {
    mainHeading: "الأسئلة الشائعة",
    subHeading: "اكتشف إجابات لأسئلة شائعة حول Flutter.",
    faqData: [
      {
        id: "collapseOne",
        question: "ما هو Flutter ولماذا يجب أن أستخدمه لتطبيقات الهاتف المحمول؟",
        answer: "Flutter هو إطار عمل يساعد المطورين على بناء تطبيقات الهاتف المحمول لكل من نظامي iOS و android باستخدام قاعدة رمز واحدة. إنه سريع وفعال ويسمح بتطبيقات جميلة وعالية الأداء. يجب عليك استخدامه لأنه يوفر الوقت والمال عن طريق إلغاء الحاجة إلى تطوير تطبيقات منفصلة لكل منصة.",
      },
      {
        id: "collapseTwo",
        question: "كم يستغرق تطوير تطبيق جوال باستخدام Flutter؟",
        answer: "يعتمد الوقت المستغرق لتطوير تطبيق باستخدام Flutter على تعقيد التطبيق وميزاته. ومع ذلك، نظرًا لأن Flutter يسمح للمطورين باستخدام قاعدة رمز واحدة لكل من iOS و android، فإنه عادة ما يسرع عملية التطوير مقارنة بالطرق التقليدية.",
      },
      {
        id: "collapseThree",
        question: "هل يمكنني ترحيل تطبيقي الحالي للجوّال إلى Flutter؟",
        answer: "نعم، يمكنك ترحيل تطبيقك الحالي إلى Flutter. يمكن لخبراء Flutter لدينا مساعدتك في نقل تطبيقك الحالي إلى Flutter دون تعطيل وظائفه، مما يمنحك جميع مزايا التطوير الأسرع والأداء الأفضل.",
      },
      {
        id: "fourth",
        question: "كم تكلفة توظيف مطوري Flutter؟",
        answer: "تعتمد تكلفة توظيف مطوري Flutter على تعقيد مشروعك ونموذج التعاقد (دوام كامل، أو دوام جزئي، أو بالساعة). من خلال توظيف مطوري Flutter، فإنك توفر الوقت وتقلل التكاليف مقارنة ببناء تطبيقات منفصلة لنظامي iOS و android.",
      },
      {
        id: "fifth",
        question: "كيف يمكنني التأكد من أن Flutter هو الخيار الصحيح لتطبيقي؟",
        answer: "إذا كنت بحاجة إلى تطبيق متعدد المنصات مع تطوير سريع وأداء ثابت على كل من iOS و android، فإن Flutter هو خيار رائع. يمكن لفريقنا مساعدتك في تحديد ما إذا كان Flutter هو الخيار الأفضل بناءً على ميزات تطبيقك واحتياجات عملك.",
      },
      {
        id: "sixth",
        question: "ما نوع الدعم الذي تقدمونه بعد تطوير التطبيق؟",
        answer: "نحن نقدم دعمًا وصيانة كاملين لتطبيق Flutter الخاص بك بعد تطويره. يتضمن ذلك إصلاح الأخطاء وإضافة ميزات جديدة والتأكد من أن التطبيق يستمر في العمل بسلاسة على كلا النظامين الأساسيين.",
      },
    ],
  },
};